export default __webpack_public_path__ + "static/media/cineonhubIconWhite.db0fb942.svg";